import React, { useState, useEffect, useContext, useRef } from 'react';
import { ThemeContext } from "../../Layout/Theme/ThemeContext";
import { useNavigate, Link, useLocation } from 'react-router-dom';
import AgreementService from "../Controller/AgreementController";
import AgreementDetailModal from "./AgreementDetail";
import Common from '../../Common/Common';
import $ from 'jquery';
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import Swal from 'sweetalert2';
import HelpSite from "../../Common/HelpLink";
import useSaleOrder from "./AgreementForms/useSaleOrder";
import useInvoice from "./AgreementForms/useInvoice";
import ModuleService from "../../Setup/controller/ModuleController/ModuleController";
import { useTranslation } from 'react-i18next';
import ColumnOptionDropDown from "../../Lead/Views/LeadForms/ColumnOptionDropDown";
import Cookies from "js-cookie";
import { formatDateWithFns } from '../../Common/DateInputFormat';
import useDateFormat from '../../Common/fetchDateFormat';
import LockReleaseService from "../../Setup/controller/LockReleaseController/LockModuleController";
import SendEmail from "../../Common/SendEmail";
import MultipleEmail from "../../Common/MultipleEmail";
import CustomerService from "../../Customer/Controller/CustomerController";
import MultiSearchDropDown from "../../Common/MultiSearchDropDown";

import JasperReportService from '../../Dashboard/Controller/JasperReportController';
import axiosInstance from '../../../config/axiosInstance';
import Draggable from 'react-draggable';
import ReportService from "../../Setup/controller/ReportController/ReportController";
import TermsConditionService from "../../Setup/controller/TermsConditionController/TermsConditionController";
import BASE_URL from "../../../config/config";
import { PDFDocument } from "pdf-lib";
import CompanySetupController from "../../SuperAdmin/Controller/Client/SACompanyListController";
function AgreementList({ ClientCompanyID }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const redirectCallback = () => {
    navigate('/'); // Redirect to the login page
  };
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };
  const redirecttoUnAuthorzied = () => {
    navigate('/Unauthorized'); // Redirect to the login page
  };
  const CompanyID = localStorage.getItem("CompanyID");
  const tableRef = useRef();
  const FormAction = "/AgreementList";
  //FormPermissionService.HasPerimssion(redirectCallback, RoleID, FormAction);

  const [modalInstance, setModalInstance] = useState(null);
  const { theme, toggleTheme } = useContext(ThemeContext);
  let accordTheme = "accordion-header-light";
  if (theme == "dark") {
    accordTheme = "accordion-header-dark";
  }
  const [agreementList, setAgrreementData] = useState([]);
  const [showAssetDetailModal, setShowAssetDetailModal] = useState(false); // State to control AssetDetailModal visibility
  const [modalInstanceCustomerDetail, setModalInstanceCustomerDetail] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedId, setSelectedId] = useState("0");
  const [selectedParts, setSelectedParts] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [multipleIds, setMultipleIds] = useState([]);
  const [currentPage, setCurrentPage] = useState(1); // Current page
  const [totalPages, setTotalPages] = useState(1); // Total number of pages
  const [searchQuery, setSearchQuery] = useState('');
  const [poCount, setPOCount] = useState(0);
  const activeDateFormat = useDateFormat();
  const [recentSearches, setRecentSearches] = useState([]);
  const setPageSizeInCookie = (pageSize) => {
    document.cookie = `pageSize=${pageSize};path=/;max-age=31536000`; // 1 year
  };
  const getPageSizeFromCookie = () => {
    const match = document.cookie.match(new RegExp('(^| )pageSize=([^;]+)'));
    return match ? parseInt(match[2], 10) : 10; // Default to 10 if no cookie is found
  };
  const [pageSize, setPageSize] = useState(getPageSizeFromCookie());

  const UserID = localStorage.getItem("UserID");
  const setSortConfigInCookie = (config) => {
    Cookies.set(`AgreementSort_${CompanyID}_${UserID}`, JSON.stringify(config), { expires: 365 });
  };
  const getSortConfigFromCookie = () => {
    const sortCookie = Cookies.get(`AgreementSort_${CompanyID}_${UserID}`);
    return sortCookie ? JSON.parse(sortCookie) : { key: 'ID', direction: 'desc' };
  };
  const [sortConfig, setSortConfig] = useState(getSortConfigFromCookie());
  async function fetchSearchLog() {
    try {

      const searchList = await CustomerService.GetSearchLog("9");
      setRecentSearches(searchList);
    } catch (error) {
      console.error('Error fetching Roles:', error);
    }
  }
  useEffect(() => {
    fetchAgreement(currentPage, pageSize);
    UserLockRelease();
    fetchSearchLog();
  }, [currentPage, pageSize]);
  useEffect(() => {
    fetchAgreement(currentPage, pageSize);
  }, [sortConfig]);

  const UserLockRelease = async () => {
    try {
      const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
      };
      const CompanyID = localStorage.getItem("CompanyID");
      if (CompanyID === null || CompanyID === "null") {
        redirectCallback();
      }
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "2");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "3");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "4");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "5");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "6");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "7");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "8");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "9");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "10");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "15");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "17");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "18");

    } catch (error) {
      console.error('Error fetching Teams:', error);
    }
  };
  const fetchAgreement = async (page, size) => {
    try {

      setLoading(true);
      const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
      };

      const Start = Math.round((parseInt(page) * parseInt(size)) - (size - 1)).toString();
      const PageSize = size.toString();

      const agreementData = await AgreementService.AllNewAgreement(redirectCallback, ClientCompanyID, Start.toString(), PageSize.toString(),
        searchQuery.toString(), sortConfig.key.toString(), sortConfig.direction.toString(), searchColumns.toString());
      setAgrreementData(agreementData);

      const agreementCount = await AgreementService.GetAgreementCount(redirectCallback, ClientCompanyID, searchQuery, searchColumns.toString());
      setPOCount(agreementCount[0].TotalRecords);
      setTotalPages(Math.ceil(agreementCount[0].TotalRecords / size));
    } catch (error) {
      console.error('Error fetching Teams:', error);
    }
    finally {
      setLoading(false); // Stop loading after fetching
    }
  };
  useEffect(() => {
    fetchAgreement("0", pageSize);

  }, [ClientCompanyID]);

  const handleCloseModal = async (isChanged) => {
    const closeModal = async () => {
      await AgreementService.UnLockContract(localStorage.getItem('AgreementID'));
      if (localStorage.getItem('HasRecordUpdated') == "1") {

        fetchAgreement("0", pageSize);
      }
      setMultipleIds([]);
      setIsModalOpen(false);
    };

    if (isChanged != true) {
      closeModal();
      return;
    }

    Swal.fire({
      title: 'Are you sure?',
      text: `Are you sure you want to close this record?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, close it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        closeModal();
      }
    });
  };
  const handleDeleteClick = async (event) => {
    event.stopPropagation(); // Prevent the row click event
    if (multipleIds.length > 0) {
      Swal.fire({
        title: 'Are you sure?',
        text: `You are about to delete ${multipleIds.length} record(s). This cannot be undone!`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: t('confirmDelete')
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await AgreementService.DeleteAgreement(multipleIds);
            setMultipleIds([]);
            fetchAgreement("0", pageSize);
            setSelectedId("0");
            Swal.fire(
              t('deleteSuccess'),
              t('deleteSuccessMessage'),
              'success'
            );
          } catch (error) {
            console.error('Error deleting job:', error);
            Swal.fire(
              'Error!',
              'There was a problem deleting the record.',
              'error'
            );
          }
        }
      });
    }
    else {
      Swal.fire(
        t('error'),
        t('checkOneRecord'),
        'warning'
      );
    }
  };


  const handleCreateAgreementClick = () => {
    localStorage.setItem('AgreementID', "");
    localStorage.setItem('AgreementID', "0");
    localStorage.setItem('HasRecordUpdated', "0");
    setIsModalOpen(true);
  };
  const handleEditClick = async (AgreementID) => {
    const IsAlreadyLeadID = localStorage.getItem('AgreementID');
    if (IsAlreadyLeadID) {
      await AgreementService.UnLockContract(IsAlreadyLeadID);
    }
    const AgreementDetail = await fetchAgreementDetail(AgreementID);
    if (AgreementDetail.length > 0) {

      localStorage.setItem('AgreementID', "");
      localStorage.setItem('AgreementID', AgreementID);
      localStorage.setItem('HasRecordUpdated', "0");
      setSelectedId(AgreementID);
      setIsModalOpen(true);

    }
  };
  const truncateText = (text, maxLength = 11) => {
    return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
  };
  const handleCheckboxChange = (event, id) => {
    event.stopPropagation();
    setSelectedId((prevSelectedId) => (prevSelectedId === id ? "0" : id)); // Toggle selection
    setMultipleIds((prevSelectedIds) => {
      if (event.target.checked) {
        return [...prevSelectedIds, id];
      } else {
        return prevSelectedIds.filter((selectedId) => selectedId !== id);
      }
    });
  };

  const fetchAgreementDetail = async (AgreementID) => {
    try {
      const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
      };
      if (AgreementID > 0) {

        const agreementDetail = await AgreementService.GetAgreementByID(redirectCallback, AgreementID);
        return agreementDetail;
      }
    } catch (error) {
      console.error('Error fetching supplier details:', error);
    }
  };

  const { handleInvoice } = useInvoice(setLoading, setSelectedParts, tableRef, fetchAgreement);
  const handleCreateInvoice = async (event) => {
    if (multipleIds.length > 0) {
      for (const id of multipleIds) {
        if (id > 0) {
          const AgreementID = id;


          const agreementDetail = await fetchAgreementDetail(AgreementID);
          if (agreementDetail[0].FK_Invoice_ID > 0) {
            Swal.fire(
              'Error!',
              'Invoice already exist for the selected agreement.',
              'warning'
            );
          }
          else {
            debugger;
            const result = await Swal.fire({
              title: 'Are you sure?',
              text: "Create invoice from the selected agreement!",
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes, Create it!'
            });

            if (result.isConfirmed) {
              const message = await handleInvoice(event, AgreementID);
              if (message === "Data saved successfully") {
                Swal.fire(
                  'Success!',
                  'Invoice Created Successfully.',
                  'success'
                );

                await fetchAgreement("0", pageSize);

              }
            }
          }
        }
      }
    }
    else {
      Swal.fire(
        'Error!',
        'Please check at least one record to create an invoice.',
        'warning'
      );
    }

  };

  const { handleSaleOrder } = useSaleOrder(setLoading, setSelectedParts, tableRef, fetchAgreement);
  const handleCreateSaleOrder = async (event) => {
    const AgreementID = selectedId;
    if (AgreementID > 0) {
      debugger;
      const agreementDetail = await fetchAgreementDetail(AgreementID);
      if (agreementDetail[0].FK_SalesOrder_ID > 0) {
        Swal.fire(
          'Error!',
          'Sale Order already exist for the selected agreement.',
          'warning'
        );
      }
      else {
        debugger;
        const result = await Swal.fire({
          title: 'Are you sure?',
          text: "Create invoice from the selected agreement!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, Create it!'
        });

        if (result.isConfirmed) {
          const message = await handleSaleOrder(event, selectedId);
          if (message === "Data saved successfully") {
            Swal.fire(
              'Success!',
              'Sale Order Created Successfully.',
              'warning'
            );
            await fetchAgreement("0", pageSize);

          }
        }
      }
    }
    else {
      Swal.fire(
        'Error!',
        'Please check at least one record to create an invoice.',
        'warning'
      );
    }

  };

  const handleRenewAgreement = async (event) => {
    if (multipleIds.length > 0) {
      for (const id of multipleIds) {
        if (id > 0) {
          const AgreementID = id;



          const agreementDetail = await fetchAgreementDetail(AgreementID);
          if (agreementDetail[0].FK_SalesOrder_ID > 0) {
            Swal.fire(
              'Error!',
              'You can not renew the selected agreement as the Sale order has been created for the selected agreement.',
              'warning'
            );
          }
          else {
            const today = new Date();
            const endDate = new Date(agreementDetail[0].contractEndDate);

            // Calculate the difference in time (in milliseconds)
            const timeDiff = endDate - today;

            // Convert time difference to days
            const dayDiff = timeDiff / (1000 * 60 * 60 * 24);

            let status = "";
            if (dayDiff < 0) {
              status = "Expired";
            } else if (dayDiff <= 30) {
              status = "Expiry";
            }
            if (status === "") {
              Swal.fire(
                'Error!',
                'Only Expired and Expiry soon agerement can be renewed.',
                'warning'
              );
            }
            else {
              debugger;
              const result = await Swal.fire({
                title: 'Are you sure?',
                text: "you wish to Renew the Selected Agreement!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, Create it!'
              });

              if (result.isConfirmed) {
                debugger;
                const message = await AgreementService.RenewAgreement(AgreementID);
                if (message === "Data saved successfully") {
                  Swal.fire(
                    'Success!',
                    'Selected Agreement renewed Successfully.',
                    'warning'
                  );
                  await fetchAgreement("0", pageSize);

                }
              }

            }
          }
        }
      }
    }
    else {
      Swal.fire(
        'Error!',
        'Please check at least one record to renew the agreement.',
        'warning'
      );
    }

  };
  const IsModuleAssigned = async () => {
    try {
      const CompanyID = localStorage.getItem("CompanyID");
      const Modules = await ModuleService.GetModuleByClientID(CompanyID, "9");
      if (Modules.length === 0) {
        Swal.fire(
          'UnAuthorzied Access!',
          'Sorry, You are not authorized to access this module.',
          'warning'
        );
        redirecttoUnAuthorzied();
      }
    } catch (error) {
      console.error('Error fetching Teams:', error);
    }
  };
  const handlePageChange = (page) => {
    setAgrreementData([]);
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);

    }
  };
  const handlePageSizeChange = (event) => {
    const newPageSize = parseInt(event.target.value, 10);
    setPageSize(newPageSize);
    setPageSizeInCookie(newPageSize);
    setCurrentPage(1); // Reset to the first page
  };
  const handleSearchButtonClick = async () => {
    setCurrentPage(1); // Reset to first page
    setAgrreementData([]); // Clear previous data
    const query = searchQuery.toLowerCase(); // Use current searchQuery state
    let columnsToSearch = searchColumns.length > 0
      ? searchColumns.join(",")
      : "ALL";
    setSearchOptions(columnsToSearch);
    const leadData = await AgreementService.AllNewAgreement(redirectCallback, ClientCompanyID, currentPage, pageSize.toString(),
      query.toString(), sortConfig.key.toString(), sortConfig.direction.toString(), columnsToSearch.toString());
    setAgrreementData(leadData);

    const leadCount = await AgreementService.GetAgreementCount(redirectCallback, ClientCompanyID, searchQuery, columnsToSearch.toString());
    setPOCount(leadCount[0].TotalRecords);
    setTotalPages(Math.ceil(leadCount[0].TotalRecords / pageSize)); // Set total pages dynamically

    const searchList = await CustomerService.GetSearchLog("9");
    setRecentSearches(searchList);
  };
  const handleSort = async (key) => {

    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }

    const newConfig = { key, direction };
    setSortConfig(newConfig);
    setSortConfigInCookie(newConfig);


    setCurrentPage(1);

    setSortConfig({ key, direction });
    const porderData = await AgreementService.AllNewAgreement(redirectCallback, ClientCompanyID, "1", pageSize.toString(),
      searchQuery.toString(), key.toString(), direction.toString(), searchColumns.toString());

    const porderCount = await AgreementService.GetAgreementCount(redirectCallback, ClientCompanyID, searchQuery, searchColumns.toString());

    setPOCount(porderCount[0].TotalRecords);
    setAgrreementData(porderData);

    setTotalPages(Math.ceil(porderCount[0].TotalRecords / pageSize));
  };

  const defaultColumns = [
    "contractNumber",
    "ACompanyName",
    "ASiteName",
    "ATitle",
    "Avc_StockName",
    "contractStartDate",
    "contractEndDate",
    "ContractFrequency",
    "NextBillingDate",
    "Abnt_OrderNumber",
    "isRenewed",
    "Astatus",
    "ModifiedBy",
  ];




  const columnOptions = [
    { value: "contractNumber", label: "Reference" },
    { value: "ACompanyName", label: "Customer" },
    { value: "ASiteName", label: "Site" },
    { value: "AEmail", label: "Email" },
    { value: "ATitle", label: "Contact" },
    { value: "Avc_StockName", label: "Details" },
    { value: "contractStartDate", label: "Start Date" },
    { value: "contractEndDate", label: "End Date" },
    { value: "ContractFrequency", label: "Billing Frequency" },
    { value: "NextBillingDate", label: "Next Billing Date" },
    { value: "Abnt_OrderNumber", label: "Sale Order" },
    { value: "isRenewed", label: "Renewed" },
    { value: "Astatus", label: "Status" },
    { value: "UpdatedDate", label: "Updated Date" },
    { value: "AssignTo", label: "AssignTo" },
    { value: "ModifiedBy", label: "ModifiedBy" }
  ];
  const getStoredColumns = () => {
    const storedColumns = Cookies.get(`AgreementColumns_${CompanyID}`);
    return storedColumns ? JSON.parse(storedColumns) : columnOptions.map(option => option.value);
  };

  const [visibleColumns, setVisibleColumns] = useState(getStoredColumns());
  const handleColumnChange = (selectedOptions) => {
    setVisibleColumns(selectedOptions);

    // Save selection to cookies (valid for 1 year)
    Cookies.set(`AgreementColumns_${CompanyID}`, JSON.stringify(selectedOptions), { expires: 365 });
  };

  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
  const [Email, setEmail] = useState();
  const [ContactIDForEmail, setContactIDForEmail] = useState();
  const [isMultipleEmailModalOpen, setIsMultipleEmailModalOpen] = useState(false);
  const [multipleEmails, setMultipleEmails] = useState([]);
  const [lastCheckedIndex, setLastCheckedIndex] = useState(null);
  const handleEmailClick = async (event, contact) => {
    event.stopPropagation();
    setEmail(contact.Email);
    setContactIDForEmail(contact.FK_ClientContact_ID)
    setIsEmailModalOpen(true);
  };
  const handleCloseEmailModal = async () => {

    setIsEmailModalOpen(false);
    fetchAgreement("0", pageSize);
  };
  const handleSendMultipleEmail = async () => {
    if (multipleIds.length > 0) {

      const emails = multipleIds
        .map(id => {
          const contact = agreementList.find(c => c.ContractID === id);
          return contact ? contact.Email : '';
        })
        .filter(email => email);
      setMultipleEmails(emails);
      setIsMultipleEmailModalOpen(true);

    }
    else {
      Swal.fire(
        'Error!',
        'Please select at least one record to send email.',
        'error'
      );
    }
  }
  const handleCheckboxClick = (event, id, index) => {
    event.stopPropagation();

    const isChecked = event.target.checked;

    if (event.shiftKey && lastCheckedIndex !== null) {
      const start = Math.min(lastCheckedIndex, index);
      const end = Math.max(lastCheckedIndex, index);
      const idsInRange = agreementList.slice(start, end + 1).map(l => l.ContractID);

      setMultipleIds(prev => {
        const s = new Set(prev);
        if (isChecked) {
          idsInRange.forEach(x => s.add(x));     // range select
        } else {
          idsInRange.forEach(x => s.delete(x));  // range unselect
        }
        return Array.from(s);
      });
    } else {
      // normal single toggle
      setMultipleIds(prev => {
        const s = new Set(prev);
        if (isChecked) s.add(id); else s.delete(id);
        return Array.from(s);
      });
    }

    // Always update the anchor index
    setLastCheckedIndex(index);

  };

  const defaultColumnsForSearch = [
    "contractNumber",
    "ACompanyName",
    "ASiteName",

    "ATitle",
    "Avc_StockName",
    "contractStartDate",
    "contractEndDate",
    "ContractFrequency",
    "NextBillingDate",
    "Abnt_OrderNumber",
    "isRenewed",
    "Astatus",
    "ModifiedBy"
  ];
  const [searchColumns, setSearchColumns] = useState(defaultColumnsForSearch);
  const [searchOptions, setSearchOptions] = useState(defaultColumnsForSearch);
  const columnSearchOptions = [
    { value: "contractNumber", label: "Reference" },
    { value: "ACompanyName", label: "Customer" },
    { value: "ASiteName", label: "Site" },
    { value: "AEmail", label: "Email" },
    { value: "ATitle", label: "Contact" },
    { value: "Avc_StockName", label: "Details" },
    { value: "contractStartDate", label: "Start Date" },
    { value: "contractEndDate", label: "End Date" },
    { value: "ContractFrequency", label: "Billing Frequency" },
    { value: "NextBillingDate", label: "Next Billing Date" },
    { value: "Abnt_OrderNumber", label: "Sale Order" },
    { value: "isRenewed", label: "Renewed" },
    { value: "Astatus", label: "Status" },
    { value: "UpdatedDate", label: "Updated Date" },
    { value: "AssignTo", label: "Assign To" },
    { value: "ModifiedBy", label: "ModifiedBy" }

  ];
  const handleSearchColumnChange = (selectedOptions) => {
    setSearchColumns(selectedOptions);

  };
  const handleExportExcel = async () => {

    if (multipleIds.length === 0) {
      Swal.fire(
        'Warning!',
        'Please select at least one record to export.',
        'warning'
      );
      return;
    }
    setLoading(true);
    try {

      // Filter only selected customers
      const selectedJob = agreementList.filter(job =>
        multipleIds.includes(job.ContractID)
      );

      if (!selectedJob || selectedJob.length === 0) {
        Swal.fire(
          'Warning!',
          'No selected data to export.',
          'warning'
        );
        return;
      }

      const headers = visibleColumns.map(col =>
        columnOptions.find(opt => opt.value === col)?.label || col
      );

      const rows = selectedJob.map(row =>
        visibleColumns.map(col => {
          let value = row[col];
          if (col === "ACompanyName") {
            value = `${row.CompanyName ?? ""}`;
          }
          if (col === "ATitle") {
            value = `${row.ContactName ?? ""}`;
          }
          if (col === "AEmail") {
            value = `${row.Email ?? ""}`;
          }
          if (col === "Avc_StockName") {
            value = `${row.vc_StockName ?? ""}`;
          }
          if (col === "Abnt_OrderNumber") {
            value = `${row.InvoiceNo ?? ""}`;
          }

          return `"${(value ?? '').toString().replace(/"/g, '""')}"`;
        }).join(',')
      );

      const csvContent = [
        headers.join(','), // CSV Header
        ...rows            // CSV Rows
      ].join('\n');

      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Agreement.csv');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

    } catch (error) {
      console.error('Error exporting selected customers:', error);
    } finally {
      setLoading(false);
    }
  };


  const getInitialWidths = () => {
    const saved = Cookies.get(`AgreementColumnWidths_${CompanyID}_${UserID}`);
    const defaults = {};

    visibleColumns.forEach(col => {
      defaults[col] = 110;
    });

    if (!saved) return defaults;

    const parsed = JSON.parse(saved);
    const applied = {};

    visibleColumns.forEach(col => {
      applied[col] = parsed[col] || 110;
    });

    return applied;
  };

  const [columnWidths, setColumnWidths] = useState(getInitialWidths);
  const startX = useRef(0);
  const startWidth = useRef(0);
  const resizingColumn = useRef(null);
  const MIN_COL_WIDTH = 60;

  /**
   * Load widths from cookie when visibleColumns changes
   */
  useEffect(() => {
    const savedWidths = Cookies.get(`AgreementColumnWidths_${CompanyID}_${UserID}`);
    if (savedWidths) {
      const parsed = JSON.parse(savedWidths);
      setColumnWidths((prev) => ({
        ...prev,
        ...parsed
      }));
    }
  }, [agreementList]);


  /**
   * Start Column Resize
   */
  const startResize = (e, key) => {
    e.stopPropagation();
    startX.current = e.clientX;
    resizingColumn.current = key;

    const th = e.target.closest("th");   // FIXED HERE
    startWidth.current = th.offsetWidth;

    document.addEventListener("mousemove", resizeColumn);
    document.addEventListener("mouseup", stopResize);
  };

  /**
   * Resize Column dynamically
   */
  const resizeColumn = (e) => {
    if (!resizingColumn.current) return;

    const delta = e.clientX - startX.current;
    const newWidth = Math.max(startWidth.current + delta, MIN_COL_WIDTH);

    setColumnWidths(prev => ({
      ...prev,
      [resizingColumn.current]: newWidth
    }));
  };
  useEffect(() => {
    setColumnWidths(getInitialWidths());
  }, [visibleColumns]);

  /**
   * Stop resizing and save to cookie
   */
  const stopResize = () => {
    document.removeEventListener("mousemove", resizeColumn);
    document.removeEventListener("mouseup", stopResize);

    const key = resizingColumn.current;
    if (key) {
      setColumnWidths(prev => {
        // Save using the most recent updated state
        Cookies.set(
          `AgreementColumnWidths_${CompanyID}_${UserID}`,
          JSON.stringify(prev),
          { expires: 365 }
        );
        return prev;
      });
    }

    resizingColumn.current = null;
  };


  /**
   * Auto-fit column width
   */
  const autoFitColumn = (key) => {
    const cells = document.querySelectorAll(`[data-col='${key}']`);
    let maxWidth = 0;

    cells.forEach(cell => {
      maxWidth = Math.max(maxWidth, cell.scrollWidth);
    });

    const newWidth = maxWidth + 20;

    const updated = { ...columnWidths, [key]: newWidth };

    setColumnWidths(updated);

    Cookies.set(
      `AgreementColumnWidths_${CompanyID}_${UserID}`,
      JSON.stringify(updated),
      { expires: 365 }
    );
  };

  const [showPdfModal, setShowPdfModal] = useState(false);
  const [imageData, setImageData] = useState(null);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [reportTitle, setReportTitle] = useState('');
  const [reportLink, setReportLink] = useState('');
  const [inputValues, setInputValues] = useState({});
  const [outputData, setOutputData] = useState([]);
  const [error, setError] = useState(null);

  const getMergedPDFBytes = async (id) => {
    try {
      const currentInputValues = {
        ClientID: localStorage.getItem("CompanyID"),
        ID: id
      };

      const redirectCallback = () => navigate('/');

      let reportData = await ReportService.GetCompanyReports(redirectCallback, "9");
      reportData = reportData.filter(x => x.IsDefault.toString() === "1");

      const reportID = reportData.length > 0 ? reportData[0].ID : 123;
      const JasperReport = await JasperReportService.GetJasperReportByID(reportID);

      const queryObjMain = {
        ...currentInputValues,
        format: 'pdf',
        ReportName: JasperReport[0].ReportName,
        ReportType: JasperReport[0].ReportType,
        name: JasperReport[0].ReportName
      };

      const responseMain = await axiosInstance.get(
        `/Dashboard/ProxyReport?${new URLSearchParams(queryObjMain)}`,
        { responseType: 'blob' }
      );

      const mainPdfBytes = await responseMain.data.arrayBuffer();

      const pdfDoc = await PDFDocument.load(mainPdfBytes);

      return pdfDoc;

    } catch (err) {
      console.error(err);
      return null;
    }
  };
  const handlePrintUser = async (event) => {
    event.stopPropagation();

    const result = await Swal.fire({
      title: "Include Terms & Conditions?",
      text: "Do you want to include Terms & Conditions in the print?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, include it",
      cancelButtonText: "No, just main report",
    });
    setLoading(true);
    const includeTerms = result.isConfirmed;

    if (multipleIds.length > 0) {
      try {
        const finalMergedPdf = await PDFDocument.create();

        // ================= MERGE INVOICES =================
        for (const id of multipleIds) {

          const pdfDoc = await getMergedPDFBytes(id);

          if (!pdfDoc) continue;

          const pages = await finalMergedPdf.copyPages(
            pdfDoc,
            pdfDoc.getPageIndices()
          );

          pages.forEach(page => finalMergedPdf.addPage(page));


          // ================= ADD TERMS ONLY ONCE =================
          if (includeTerms) {

            const companySetup = await CompanySetupController.GetCompanyByID(
              () => navigate('/'),
              localStorage.getItem("CompanyID")
            );

            const termFile = companySetup?.[0]?.TermFile;

            if (termFile) {
              const FileUrl = `${BASE_URL}/uploads/${localStorage.getItem('CompanyID')}/Admin/TermConditions/${termFile}`;

              const responseSecond = await axiosInstance.get(FileUrl, {
                responseType: 'blob'
              });

              const secondPdfBytes = await responseSecond.data.arrayBuffer();
              const secondPdf = await PDFDocument.load(secondPdfBytes);

              const secondPages = await finalMergedPdf.copyPages(
                secondPdf,
                secondPdf.getPageIndices()
              );

              secondPages.forEach(page => finalMergedPdf.addPage(page));
            }
          }
        }
        // ================= FINAL OUTPUT =================
        const finalBytes = await finalMergedPdf.save();
        const finalBlob = new Blob([finalBytes], { type: "application/pdf" });

        const finalUrl = URL.createObjectURL(finalBlob);
        setLoading(false);
        setPdfUrl(finalUrl);
        setShowPdfModal(true);

      } catch (err) {
        console.error('Error executing report:', err);
        setError('Failed to execute the report.');
      }
    } else {
      Swal.fire(
        'Error!',
        'Please check at least one record to print job.',
        'warning'
      );
    }
  };

  const handleStart = (e, ui) => {
    e.stopPropagation();
  }
  return (

    <div>
      {ClientCompanyID === 0 && (
        <Common showAddButton={'yes'} handleAddTask={handleCreateAgreementClick}
          showDeleteButton={'yes'} handleDeleteItem={handleDeleteClick}
          // showSaleOrder={'yes'} handleSaleOrder={handleCreateSaleOrder}
          showInvoice={'yes'} handleInvoice={handleCreateInvoice}
          showRenewButton={'yes'} handleRenewAgreement={handleRenewAgreement}
          showExportButton={'yes'} handleExportExcel={handleExportExcel}
          ModuleID={"9"} isDisabled={multipleIds.length > 1}
          showPrintUser={'yes'} handlePrintUser={handlePrintUser}
          HelpFormName="Agreement List" HelpModule="10"
          RecordID={multipleIds}
        />

      )}
      {loading && (
        <div class="loading">
          <div class="d-table">
            <div class="d-tablecell">
              <span class="loader">
                <span class="loader-inner"></span>
              </span>
            </div>
          </div>
        </div>
      )}
      <div className="main-content-header">
        <div className="row mb-3" style={{ marginLeft: "-5px" }}>
          {(ClientCompanyID === 0 &&
            <div className="col-xl-2">
              <h1>{t('agreement')}</h1>
            </div>
          )}
          {(ClientCompanyID > 0 &&
            <div className="col-xl-2">
              <button className='btn btn-primary btn-sm' onClick={handleCreateAgreementClick}>
                <i className="icofont-plus" aria-hidden="true"> {t('addNew')}</i>
              </button>
            </div>
          )}

          <div className="col-xl-10 d-flex justify-content-end">
            <ColumnOptionDropDown
              options={columnOptions}
              selectedOptions={visibleColumns}
              onChange={handleColumnChange}
            />


          </div>
        </div>
      </div>
      <div className="row mb-3" style={{ marginLeft: "-5px" }}>
        <div className="col-xl-12">
          <div className="card mb-30">
            <div className="card-body">

              <div className="">
                <div className="row mb-3">
                  <div className="col-sm-1">
                    <select id="pageSize" className="form-control" value={pageSize} onChange={handlePageSizeChange}>
                      <option value={10}>10</option>
                      <option value={25}>25</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                      <option value={500}>500</option>
                      <option value={1000}>1000</option>
                    </select>
                  </div>
                  <label style={{ paddingLeft: "0px" }} className="col-sm-2" htmlFor="pageSize">entries per page: </label>
                  <div className="col-sm-6"></div>
                  <div className="col-sm-1 d-flex align-items-center justify-content-end">
                    <span className="me-2">Search</span>

                    <MultiSearchDropDown
                      options={columnSearchOptions}
                      selectedOptions={searchColumns}
                      onChange={handleSearchColumnChange}
                    />
                  </div>
                  <div className="col-sm-2 d-flex justify-content-end">
                    <input
                      list="recent-searches"
                      type="text"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      className="form-control me-2"
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          handleSearchButtonClick();
                        }
                      }}
                    />
                    <datalist id="recent-searches">
                      {recentSearches.map((item, idx) => (
                        <option key={idx} value={item.SearchQuery} />
                      ))}
                    </datalist>
                    <button onClick={() => handleSearchButtonClick()} style={{ background: "none", border: "none" }}>
                      <img src="assets/img/resources/search.png" class="top-icon" alt="Add icon" />
                    </button>
                  </div>
                </div>
                <div style={{ maxHeight: "80vh", overflow: "auto" }}>
                  <table
                    style={{
                      tableLayout: "fixed",
                      width: "max-content",
                      minWidth: "100%"
                    }}
                    className="table m-0 table-hover"
                    ref={tableRef}
                  >
                    <thead classname="table-light" style={{ position: "sticky", top: 0, zindex: 2 }}>
                      <tr>
                        <th
                          className="checkbox-header"
                          style={{
                            width: "40px",
                            minWidth: "40px",
                            maxWidth: "40px",
                            position: "sticky",
                            left: 0,
                            zIndex: 5,

                          }}
                        ></th>
                        {visibleColumns.includes("contractNumber") &&
                          <th onClick={() => handleSort('contractNumber')}

                            style={{
                              width: `${columnWidths?.contractNumber}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">{t('reference')}
                            <i
                              className={`ms-1 icofont ${sortConfig.key === 'contractNumber'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "contractNumber");
                              }}
                              onDoubleClick={() => autoFitColumn("contractNumber")}
                            />
                          </th>
                        } {visibleColumns.includes("ACompanyName") &&
                          <th onClick={() => handleSort('CompanyName')}

                            style={{
                              width: `${columnWidths?.CompanyName}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">{t('customer')}<i
                              className={`ms-1 icofont ${sortConfig.key === 'CompanyName'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "CompanyName");
                              }}
                              onDoubleClick={() => autoFitColumn("CompanyName")}
                            /></th>
                        }
                        {visibleColumns.includes("ASiteName") &&
                          <th onClick={() => handleSort('SiteName')}

                            style={{
                              width: `${columnWidths?.SiteName}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">Site<i
                              className={`ms-1 icofont ${sortConfig.key === 'SiteName'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "SiteName");
                              }}
                              onDoubleClick={() => autoFitColumn("SiteName")}
                            /></th>
                        }
                        {visibleColumns.includes("ATitle") &&
                          <th onClick={() => handleSort('Title')}

                            style={{
                              width: `${columnWidths?.Title}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">{t('contact')}<i
                              className={`ms-1 icofont ${sortConfig.key === 'Title'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "Title");
                              }}
                              onDoubleClick={() => autoFitColumn("Title")}
                            /></th>
                        }
                        {visibleColumns.includes("AEmail") &&
                          <th onClick={() => handleSort('Email')}

                            style={{
                              width: `${columnWidths?.Email}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">Email<i
                              className={`ms-1 icofont ${sortConfig.key === 'Email'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "Email");
                              }}
                              onDoubleClick={() => autoFitColumn("Email")}
                            /></th>
                        }
                        {visibleColumns.includes("Avc_StockName") &&
                          <th onClick={() => handleSort('vc_StockName')}

                            style={{
                              width: `${columnWidths?.vc_StockName}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">{t('details')}<i
                              className={`ms-1 icofont ${sortConfig.key === 'vc_StockName'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "vc_StockName");
                              }}
                              onDoubleClick={() => autoFitColumn("vc_StockName")}
                            /></th>
                        }
                        {visibleColumns.includes("contractStartDate") &&
                          <th onClick={() => handleSort('contractStartDate')}

                            style={{
                              width: `${columnWidths?.contractStartDate}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">{t('startDate')}<i
                              className={`ms-1 icofont ${sortConfig.key === 'contractStartDate'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "contractStartDate");
                              }}
                              onDoubleClick={() => autoFitColumn("contractStartDate")}
                            /></th>
                        }
                        {visibleColumns.includes("contractEndDate") &&
                          <th onClick={() => handleSort('contractEndDate')}

                            style={{
                              width: `${columnWidths?.contractEndDate}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">{t('endDate')}<i
                              className={`ms-1 icofont ${sortConfig.key === 'contractEndDate'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "contractEndDate");
                              }}
                              onDoubleClick={() => autoFitColumn("contractEndDate")}
                            /></th>
                        }
                        {visibleColumns.includes("ContractFrequency") &&
                          <th onClick={() => handleSort('ContractFrequency')}

                            style={{
                              width: `${columnWidths?.ContractFrequency}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">{t('billingFrequency')}<i
                              className={`ms-1 icofont ${sortConfig.key === 'ContractFrequency'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "ContractFrequency");
                              }}
                              onDoubleClick={() => autoFitColumn("ContractFrequency")}
                            /></th>
                        }
                        {visibleColumns.includes("NextBillingDate") &&
                          <th onClick={() => handleSort('NextBillingDate')}

                            style={{
                              width: `${columnWidths?.NextBillingDate}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">{t('nextBilling')}<i
                              className={`ms-1 icofont ${sortConfig.key === 'NextBillingDate'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "NextBillingDate");
                              }}
                              onDoubleClick={() => autoFitColumn("NextBillingDate")}
                            /></th>
                        }
                        {visibleColumns.includes("Abnt_OrderNumber") &&
                          <th onClick={() => handleSort('bnt_OrderNumber')}

                            style={{
                              width: `${columnWidths?.bnt_OrderNumber}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">Invoice No.<i
                              className={`ms-1 icofont ${sortConfig.key === 'bnt_OrderNumber'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "bnt_OrderNumber");
                              }}
                              onDoubleClick={() => autoFitColumn("bnt_OrderNumber")}
                            /></th>
                        }
                        {visibleColumns.includes("AssignTo") &&
                          <th onClick={() => handleSort('AssignTo')}

                            style={{
                              width: `${columnWidths?.AssignTo}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">Assign To<i
                              className={`ms-1 icofont ${sortConfig.key === 'AssignTo'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "AssignTo");
                              }}
                              onDoubleClick={() => autoFitColumn("AssignTo")}
                            /></th>
                        }
                        {visibleColumns.includes("UpdatedDate") &&
                          <th onClick={() => handleSort('UpdatedDate')}

                            style={{
                              width: `${columnWidths?.UpdatedDate}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">Last Action
                            <i
                              className={`ms-1 icofont ${sortConfig.key === 'UpdatedDate'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "UpdatedDate");
                              }}
                              onDoubleClick={() => autoFitColumn("UpdatedDate")}
                            />
                          </th>
                        }
                        {visibleColumns.includes("ModifiedBy") &&
                          <th onClick={() => handleSort('ModifiedBy')}
                            style={{
                              width: `${columnWidths?.ModifiedBy}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">Modified By
                            <i
                              className={`ms-1 icofont ${sortConfig.key === 'ModifiedBy'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i>
                            <div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "ModifiedBy");
                              }}
                              onDoubleClick={() => autoFitColumn("ModifiedBy")}
                            />
                          </th>
                        }
                        {visibleColumns.includes("isRenewed") &&
                          <th

                            style={{
                              width: `${columnWidths?.isRenewed}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">{t('isRenewed')}<div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "isRenewed");
                              }}
                              onDoubleClick={() => autoFitColumn("isRenewed")}
                            /></th>
                        }
                        {visibleColumns.includes("Astatus") &&
                          <th

                            style={{
                              width: `${columnWidths?.vc_Company}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">{t('status')}<div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "Astatus");
                              }}
                              onDoubleClick={() => autoFitColumn("Astatus")}
                            /></th>
                        }

                      </tr>
                    </thead>
                    <tbody>
                      {agreementList.map((agreement, index) => (

                        <tr key={agreement.ContractID} onClick={() => handleEditClick(agreement.ContractID)}
                          style={{
                            backgroundColor: selectedId.toString() === agreement.ContractID.toString() ? 'rgb(197, 218, 237)' : '', // Highlight background
                            cursor: 'pointer',
                          }}>
                          <td
                            className="checkbox-cell"
                            onClick={(e) => e.stopPropagation()}
                            style={{
                              width: "40px",
                              minWidth: "40px",
                              maxWidth: "40px",
                              position: "sticky",
                              left: 0,
                              zIndex: 3,
                              backgroundColor:
                                selectedId.toString() === agreement.ContractID.toString()
                                  ? 'rgb(197, 218, 237)'
                                  : '#fff'
                            }}
                          >
                            <div
                              className="checkbox-hover-area"
                              onClick={(event) => handleCheckboxClick(event, agreement.ContractID, index)}
                            >
                              <input
                                type="checkbox"
                                checked={multipleIds.includes(agreement.ContractID)}
                                readOnly
                              />

                            </div>
                          </td>
                          {visibleColumns.includes("contractNumber") && <td style={{
                            width: columnWidths.contractNumber,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis" title={agreement.contractNumber}>{agreement.contractNumber}</td>}
                          {visibleColumns.includes("ACompanyName") && <td style={{
                            width: columnWidths.CompanyName,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis" title={agreement.CompanyName}>{agreement.CompanyName}</td>}

                          {visibleColumns.includes("ASiteName") && <td style={{
                            width: columnWidths.SiteName,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis" title={agreement.SiteName}>{agreement.SiteName}</td>}


                          {visibleColumns.includes("ATitle") && <td style={{
                            width: columnWidths.Title,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis" title={agreement.ContactName}>{agreement.ContactName}</td>}
                          {visibleColumns.includes("AEmail") && <td style={{
                            width: columnWidths.Email,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis" title={agreement.Email}>
                            <a href='#' onClick={(event) => handleEmailClick(event, agreement)}>
                              {agreement.Email}
                            </a>
                          </td>}

                          {visibleColumns.includes("Avc_StockName") && <td style={{
                            width: columnWidths.vc_StockName,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis" title={agreement.vc_StockName}>{agreement.vc_StockName}</td>}

                          {visibleColumns.includes("contractStartDate") && <td style={{
                            width: columnWidths.contractStartDate,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis">{formatDate(agreement.contractStartDate)}</td>}
                          {visibleColumns.includes("contractEndDate") && <td style={{
                            width: columnWidths.contractEndDate,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis">{formatDate(agreement.contractEndDate)}</td>}

                          {visibleColumns.includes("ContractFrequency") && <td style={{
                            width: columnWidths.ContractFrequency,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis" title={agreement.ContractFrequency}>{agreement.ContractFrequency}</td>}
                          {visibleColumns.includes("NextBillingDate") && <td style={{
                            width: columnWidths.NextBillingDate,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis">{formatDate(agreement.NextBillingDate)}</td>}
                          {visibleColumns.includes("Abnt_OrderNumber") && <td style={{
                            width: columnWidths.bnt_OrderNumber,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis">{agreement.InvoiceNo}</td>}
                          {visibleColumns.includes("AssignTo") && <td style={{
                            width: columnWidths.AssignTo,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis">
                            {agreement.AssignTo ? (
                              <div
                                title={agreement.AssignTo}
                                style={{
                                  display: "inline-flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  width: "25px",
                                  height: "25px",
                                  borderRadius: "50%",
                                  backgroundColor: "#007bff",
                                  color: "white",
                                  fontWeight: "bold",
                                  fontSize: "14px",
                                }}
                              >
                                {agreement.AssignTo.split(" ")
                                  .map(word => word.charAt(0).toUpperCase())
                                  .join("")}
                              </div>
                            ) : (
                              ""
                            )}
                          </td>}
                          {visibleColumns.includes("UpdatedDate") && <td style={{
                            width: columnWidths.UpdatedDate,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis">{formatDateWithFns(agreement.UpdatedDate, activeDateFormat)}  </td>}


                          {visibleColumns.includes("ModifiedBy") && <td style={{
                            width: columnWidths.ModifiedBy,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis">
                            {agreement.ModifiedBy ? (
                              <div
                                title={agreement.ModifiedBy}
                                style={{
                                  display: "inline-flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  width: "25px",
                                  height: "25px",
                                  borderRadius: "50%",
                                  backgroundColor: "#368938",
                                  color: "white",
                                  fontWeight: "bold",
                                  fontSize: "14px",
                                }}
                              >
                                {agreement.ModifiedBy.split(" ")
                                  .map(word => word.charAt(0).toUpperCase())
                                  .join("")}
                              </div>
                            ) : (
                              ""
                            )}
                          </td>}



                          {visibleColumns.includes("isRenewed") &&
                            <td style={{
                              width: columnWidths.isRenewed,
                              minWidth: MIN_COL_WIDTH,
                            }} className="no-wrap ellipsis">

                              {agreement.bit_Renewed === 1 && (
                                <img src='assets/img/resources/tick.png' style={{ width: "20px" }}></img>
                              )}
                            </td>
                          }
                          {visibleColumns.includes("Astatus") &&
                            <td style={{
                              width: columnWidths.status,
                              minWidth: MIN_COL_WIDTH,
                            }} className="no-wrap ellipsis">
                              {(() => {
                                const today = new Date();
                                const endDate = new Date(agreement.contractEndDate);

                                // Calculate the difference in time (in milliseconds)
                                const timeDiff = endDate - today;

                                // Convert time difference to days
                                const dayDiff = timeDiff / (1000 * 60 * 60 * 24);

                                if (dayDiff < 0) {
                                  return <img src="assets/img/resources/red.png" className="" alt="Expired icon" />;
                                } else if (dayDiff <= 30) {
                                  return <img src="assets/img/resources/orange.png" className="" alt="Expiring Soon icon" />;
                                } else {
                                  return <img src="assets/img/resources/green.png" className="" alt="Normal icon" />;
                                }
                              })()}
                            </td>
                          }
                        </tr>
                      ))}
                    </tbody>
                    <tfoot style={{ position: "sticky", bottom: 0, zIndex: 2, backgroundColor: "white" }}>
                      <tr>
                        <td colSpan={visibleColumns.length + 1}>
                          <div className="pagination-controls" style={{ marginTop: "10px", marginBottom: "10px" }}>
                            Showing {1 + (currentPage * pageSize) - pageSize} to {currentPage * (Math.min(poCount, pageSize))} of {poCount} entries

                            {/* Last Page Button */}
                            <button
                              style={{ float: "right", marginLeft: "5px" }}
                              className='btn btn-info'
                              onClick={() => handlePageChange(totalPages)} // Navigate to last page
                              disabled={currentPage === totalPages}
                            >
                              <img src="assets/img/resources/last.png" alt="Add icon" style={{ height: "10px" }} />  Last
                            </button>

                            {/* Next Page Button */}
                            <button
                              style={{ float: "right", marginLeft: "5px" }}
                              className='btn btn-info'
                              onClick={() => handlePageChange(currentPage + 1)}
                              disabled={currentPage === totalPages}
                            >
                              <img src="assets/img/resources/next-icon.png" alt="Add icon" style={{ height: "10px" }} /> Next
                            </button>

                            <span style={{ marginLeft: "10px", marginRight: "10px", float: "right" }}>
                              Page {currentPage} of {totalPages}
                            </span>

                            {/* Previous Page Button */}
                            <button
                              style={{ float: "right", marginRight: "5px", marginLeft: "5px" }}
                              className='btn btn-info'
                              onClick={() => handlePageChange(currentPage - 1)}
                              disabled={currentPage === 1}
                            >
                              <img src="assets/img/resources/pevious-icon.png" alt="Add icon" style={{ height: "10px" }} /> Prev
                            </button>

                            {/* First Page Button */}
                            <button
                              style={{ float: "right" }}
                              className='btn btn-info'
                              onClick={() => handlePageChange(1)} // Navigate to first page
                              disabled={currentPage === 1}
                            >
                              <img src="assets/img/resources/first.png" alt="Add icon" style={{ height: "10px" }} />  First
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tfoot>
                  </table>

                </div>
                {isModalOpen && (
                  <AgreementDetailModal AgreementID={localStorage.getItem('AgreementID')} onClose={handleCloseModal} onSuccess={fetchAgreement} ClientCompanyID={ClientCompanyID} />
                )}

              </div>
            </div>
          </div>
        </div>
      </div>
      {isEmailModalOpen && (
        <SendEmail onClose={handleCloseEmailModal} ToEmail={Email} Module="Customer" ModuleID={ContactIDForEmail} />
      )}
      {isMultipleEmailModalOpen && (
        <MultipleEmail
          onClose={() => setIsMultipleEmailModalOpen(false)}
          ToEmail={multipleEmails} // remove empty strings
          Module="Contact"
          ModuleID={ClientCompanyID}
          MultipleIDs={multipleIds}
        />
      )}
      {showPdfModal && pdfUrl && (
        <div className="modal fade show d-block" tabIndex="-1">
          <div className="modal-dialog modal-lg">
            <Draggable handle=".modal-content" onStart={handleStart}>
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">PDF Report</h5>
                  <button type="button" className="close" onClick={() => setShowPdfModal(false)}>
                    <span>&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  <embed src={pdfUrl} type="application/pdf" width="100%" height="600px" />
                </div>
              </div>
            </Draggable>
          </div>
        </div>
      )}
    </div>


  );
}
export default AgreementList;